import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './fk-about.module.css';
import Decort from '../../public/fitkonnekt/about/decort.svg';
import { Container } from '../../components';

export interface CardAboutProps {
  src: string;
  text: string;
  title: string;
}

const aboutListCard: CardAboutProps[] = [
  {
    src: '/video/plank.mp4',
    text: 'Designed specifically for use with Bluetooth headphones, the Fitkonnekt Interval Training Portal provides an immersive digital workout experience. The on-screen “interval timer”, “audible beeps”, and “exercise name” displayed on-screen, will serve as your Trainer.',
    title: 'Profile',
  },
  {
    src: '/video/pushup.mp4',
    text: 'We developed a very flexible workout flow where you can be a trainer or participant. App allows to perform HIIT, TABATA, and EMOM interval workouts with your buddies in training sessions ranging from fifteen minutes to one hour in duration.',
    title: 'Profile',
  },
  {
    src: '/video/girl_phone.mp4',
    text: "We collect all the information and keep it in the profile section for the user's convenience. You may see the workout history, upcoming workouts, workout buddies and one-to-one chats in one place.",
    title: 'Profile',
  },
];

function CardAbout({ src, text, title }: CardAboutProps) {
  return (
    <div className={styles.aboutCard}>
      <div className={styles.aboutCard_start}>
        <div className={styles.aboutCard_image}>
          <video autoPlay loop muted playsInline>
            <source src={src} type="video/mp4" />
          </video>
        </div>
      </div>
      <div className={styles.aboutCard_end}>
        <h3 className={styles.aboutCard_title}>{title}</h3>
        <div className={styles.aboutCard_text}>
          {text && text.split(/[\r\n]+/g).map((t, i) => <p key={i}>{t}</p>)}
        </div>

        <div className={styles.aboutCard_decorat}>
          <Decort />
        </div>
      </div>
    </div>
  );
}

function FKAbout() {
  return (
    <section className={styles.about}>
      <Container>
        <AnimationOnScroll
          offset={400}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInUp"
        >
          <h2 className={styles.about_title}>
            About <span>Fit</span>Konnekt App
          </h2>
        </AnimationOnScroll>

        <ul className={styles.list}>
          {aboutListCard &&
            aboutListCard.map((props, index) => (
              <li className={styles.list_item} key={index}>
                <AnimationOnScroll
                  offset={400}
                  animateOnce
                  duration={1.2}
                  animateIn="animate__fadeInUp"
                >
                  <CardAbout {...props} />
                </AnimationOnScroll>
              </li>
            ))}
        </ul>
      </Container>
    </section>
  );
}
export default FKAbout;
